<!-- 授权弹窗 -->
<script setup lang="ts">
import { useGlobalState } from '../../hooks/useGlobalState'
import * as helpers from '../../wallet/helpers'
import TtxsTextWhite from './components/TtxsTextWhite.vue'

const $prors = withDefaults(defineProps<Prors>(), {
  who: () => '',
  modelValue: true,
  loading: false,
  src: 'https://transfer.swft.pro/swft-v3/images/coins/TRX.png',
})

const emit = defineEmits(['update:modelValue', 'onSubmit'])

const state = useGlobalState()

interface Prors {
  who?: string | number
  modelValue?: boolean
  loading?: boolean
  src?: string
}
function onClose() {
  emit('update:modelValue', false)
}
const show = ref($prors.modelValue)
function setShow(e: boolean) {
  show.value = e
}
watch(() => $prors.modelValue, setShow)
</script>

<template>
  <AModal v-model:open="show" :width="420" wrapClassName="ant-cover__basic-modal TTXS" :footer="null" :maskClosable="false" @cancel="onClose">
    <div>
      <header class="flex justify-center items-center py-3">
        <img class="w-80px h-80px" :src="src">
      </header>
      <div class="my-2 text-center">
        <p><TtxsTextWhite><slot>Approve {{ helpers.formatAmount(state.fromMoney.amount) }} {{ state.fromCurrency.symbol_show }}</slot></TtxsTextWhite></p>
        <p class="my-2">{{ $t('z5vFuPsz0FbaUtw3uPuWs') }}</p>
      </div>
      <footer class="mt-8">
        <AButton :loading="loading" class="w-100% comfirm-btn" data-test-id="qzr4" @click="emit('onSubmit', { key: 'onSubmit', $event, $prors })">{{ $t('3fo1ys1Sb3Fx2Eaj4aCwA') }}</AButton>
      </footer>
    </div>
  </AModal>
</template>

<style lang="scss" scoped>
@use "../../../../style/deep-ant.scss";
</style>
